/* ==========================================================================
   PINO fixes (sept 2026, bugtest draft "Update 3")
   Geladen in layout/theme.liquid (defer). Kleine gedragsfixes, themabreed:
   1. Chatknop (Shopify Inbox): even weg zolang hij een knop, link of veld
      bedekt, en terug zodra er niets meer onder ligt. De chat zelf (open
      paneel) wordt nooit verborgen.
   2. Escape sluit de winkelwagen (cart drawer).
   3. Taal- en landkeuze in de header bereikbaar en bedienbaar met het
      toetsenbord (Tab, Enter, spatie, pijltjes, Escape).
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. Chatknop ------------------------------------------------ */
  var CLICKABLE = 'a[href], button, input:not([type="hidden"]), select, textarea, label, summary, [role="button"], [tabindex]:not([tabindex="-1"])';
  var chat = null, chatTick = false;

  function chatHost() {
    if (!chat || !chat.isConnected) chat = document.querySelector('shopify-chat');
    return chat && chat.shadowRoot ? chat : null;
  }

  function prepChat(c) {
    var sr = c.shadowRoot;
    if (sr.querySelector('style[data-pino-fix]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-pino-fix', '');
    st.textContent =
      '.activator-nudge{transition:opacity .2s ease}' +
      ':host(.pino-chat-away:not([open])) .activator-nudge{opacity:0!important;pointer-events:none!important}' +
      ':host(.pino-chat-away:not([open])) .activator-nudge *{pointer-events:none!important}';
    sr.appendChild(st);
  }

  function coversSomething(rect, c) {
    var inset = 6;
    var pts = [
      [rect.left + rect.width / 2, rect.top + rect.height / 2],
      [rect.left + inset, rect.top + inset],
      [rect.right - inset, rect.top + inset],
      [rect.left + inset, rect.bottom - inset],
      [rect.right - inset, rect.bottom - inset]
    ];
    for (var i = 0; i < pts.length; i++) {
      var x = pts[i][0], y = pts[i][1];
      if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) continue;
      var stack = document.elementsFromPoint(x, y);
      for (var j = 0; j < stack.length; j++) {
        var el = stack[j];
        if (el === c || c.contains(el)) continue;
        if (el === document.documentElement || el === document.body) break;
        if (el.closest(CLICKABLE)) return true;
        break;
      }
    }
    return false;
  }

  function placeChat() {
    var c = chatHost();
    if (!c) return false;
    prepChat(c);
    if (c.hasAttribute('open')) { c.classList.remove('pino-chat-away'); return true; }
    var nudge = c.shadowRoot.querySelector('.activator-nudge');
    if (!nudge) return false;
    /* Eerst terugzetten om de echte positie te meten, dan beslissen */
    var was = c.classList.contains('pino-chat-away');
    var r = nudge.getBoundingClientRect();
    if (!r.width) return true;
    if (was) c.classList.remove('pino-chat-away');
    var hit = coversSomething(r, c);
    c.classList.toggle('pino-chat-away', hit);
    return true;
  }

  function queueChat() {
    if (chatTick) return;
    chatTick = true;
    requestAnimationFrame(function () { chatTick = false; placeChat(); });
  }
  window.addEventListener('scroll', queueChat, { passive: true });
  window.addEventListener('resize', queueChat);
  document.addEventListener('click', function () { setTimeout(queueChat, 350); }, true);
  var chatTries = 0;
  var chatTimer = setInterval(function () {
    chatTries++;
    placeChat();
    if (chatTries > 40) clearInterval(chatTimer);
  }, 750);

  /* ---------- 2. Escape sluit de winkelwagen ----------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var drawer = document.querySelector('m-cart-drawer.m-cart-drawer--active');
    if (!drawer) return;
    var close = drawer.querySelector('.m-cart-drawer__close');
    if (close) { e.preventDefault(); close.click(); }
  });

  /* ---------- 2b. Set-blok: lange Nederlandse samenstellingen afbreken ---- */
  /* "Snorhaarvriendelijk" past niet in een tegel van 72px. Een zacht
     afbreekstreepje geeft "Snorhaar-" / "vriendelijk" in elke browser. */
  function softHyphens(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.ppdp__set-item span'), function (el) {
      var t = el.textContent;
      if (t.indexOf('\u00AD') > -1) return;
      var n = t.replace(/([A-Za-z\u00C0-\u017F]{5,})(vriendelijk|bestendig)/, '$1\u00AD$2');
      if (n !== t) el.textContent = n;
    });
  }
  function watchSets() {
    Array.prototype.forEach.call(document.querySelectorAll('.ppdp__set-items'), function (box) {
      if (box.hasAttribute('data-pino-hy')) return;
      box.setAttribute('data-pino-hy', '');
      softHyphens(box);
      if ('MutationObserver' in window) new MutationObserver(function () { softHyphens(box); }).observe(box, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSets);
  else watchSets();

  /* ---------- 3. Taal- en landkeuze met het toetsenbord ------------------ */
  function initSelect(box) {
    if (box.hasAttribute('data-pino-kb')) return;
    var trigger = box.querySelector('.m-select-custom--trigger');
    var list = box.querySelector('.m-select-custom--options');
    if (!trigger || !list) return;
    box.setAttribute('data-pino-kb', '');
    box.removeAttribute('aria-hidden');
    var label = box.closest('.m-country-switcher') ? 'Land / regio' : 'Taal';
    if ((document.documentElement.lang || '').indexOf('nl') !== 0) {
      label = box.closest('.m-country-switcher') ? 'Country / region' : 'Language';
    }
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', label + ': ' + (trigger.textContent || '').trim());
    list.setAttribute('role', 'listbox');
    var opts = Array.prototype.slice.call(list.querySelectorAll('.m-select-custom--option, [data-value]'));
    opts.forEach(function (o) { o.setAttribute('role', 'option'); o.setAttribute('tabindex', '-1'); });

    function isOpen() {
      var cs = window.getComputedStyle(list);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0' && list.getBoundingClientRect().height > 0;
    }
    function sync() { trigger.setAttribute('aria-expanded', isOpen() ? 'true' : 'false'); }

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen()) trigger.click();
        setTimeout(function () {
          sync();
          var cur = list.querySelector('.is-selected, .selected, [aria-selected="true"]') || opts[0];
          if (cur) { cur.setAttribute('tabindex', '0'); cur.focus(); }
        }, 60);
      } else if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        trigger.click();
        setTimeout(sync, 60);
      }
    });
    list.addEventListener('keydown', function (e) {
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = opts[(i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
        if (n) { n.setAttribute('tabindex', '0'); n.focus(); }
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (i > -1) opts[i].click();
      } else if (e.key === 'Escape' || e.key === 'Tab') {
        if (isOpen()) trigger.click();
        setTimeout(sync, 60);
        if (e.key === 'Escape') { e.preventDefault(); trigger.focus(); }
      }
    });
    trigger.addEventListener('click', function () { setTimeout(sync, 60); });
  }

  function initSelects() {
    Array.prototype.forEach.call(document.querySelectorAll('.m-select-custom.js-selectCustom'), initSelect);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSelects);
  else initSelects();
  window.addEventListener('load', initSelects);
})();
